import { CKButton } from '@clearkit/react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MenuItem from '@material-ui/core/MenuItem';

import Select from '~/components/SelectWithLabel';
import TextField from '~/components/TextField';

export default class NewFormDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      clone_id: '',
      nameError: false,
    };
  }

  validate = (event) => {
    event.preventDefault();

    if (this.state.name === '') {
      return this.setState({
        nameError: true,
      });
    }

    this.props.onClose(true, this.state);
  };

  render() {
    const { open, onClose, forms } = this.props;
    const { name, nameError, clone_id } = this.state;

    return (
      <Dialog open={open} onExited={() => onClose(false)}>
        <DialogContent>
          <form onSubmit={this.validate}>
            <TextField
              error={nameError}
              variant="outlined"
              required
              fullWidth
              value={name}
              onChange={(e) =>
                this.setState({ name: e.target.value, nameError: false })
              }
              label="Name this form"
            />

            {forms.length > 0 && (
              <Select
                fullWidth
                margin="dense"
                label="Clone from... (optional)"
                onChange={(e) => this.setState({ clone_id: e.target.value })}
                value={clone_id}>
                {forms.map((form) => (
                  <MenuItem value={form.id} key={form.id}>
                    {form.name}
                  </MenuItem>
                ))}
              </Select>
            )}
          </form>
        </DialogContent>

        <DialogActions>
          <CKButton variantColor="red" onClick={() => onClose(false)}>
            Cancel
          </CKButton>

          <CKButton
            onClick={this.validate}
            variantColor="blue"
            variant="bold"
            autoFocus>
            Done
          </CKButton>
        </DialogActions>
      </Dialog>
    );
  }
}

NewFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  forms: PropTypes.array.isRequired,
};
